/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrganisationRolesJobTitles } from './organisationRolesJobTitles';


/**
 * Добавить пользователя.
 */
export interface AddUser { 
    /**
     * Имя.
     */
    firstName?: string;
    /**
     * Отчество.
     */
    middleName?: string;
    /**
     * Фамилия.
     */
    lastName?: string;
    /**
     * Пол.
     */
    gender?: string;
    /**
     * Электронная почта.
     */
    email?: string;
    /**
     * Телефон.
     */
    phone?: string;
    /**
     * Описание.
     */
    aboutMessage?: string;
    /**
     * Отображать ли сотрудника в контактах компании.
     */
    isPublicContact?: boolean;
    /**
     * 
     */
    telegramId?: number;
    /**
     * Организации пользователя, роли и должности.
     */
    organisations?: Array<OrganisationRolesJobTitles>;
    /**
     * Должность.
     */
    jobTitleDescription?: string;
    /**
     * Дата рождения.
     */
    birthDate?: string;
    /**
     * Присылать оповещение о новом мероприятии/опросе на почту.
     * @deprecated
     */
    notifyByEmail?: boolean;
    /**
     * потребности.
     */
    needs?: string;
    /**
     * возможности.
     */
    resources?: string;
    /**
     * хобби.
     */
    hobbies?: string;
    /**
     * взнос оплачен.
     */
    isFeePaid?: boolean;
    /**
     * ID куратора.
     */
    curatorId?: string;
    /**
     * полномочия действительны до.
     */
    authorityValidTill?: string;
    /**
     * Дата принятия соглашения.
     */
    policiesAcceptanceDate?: string;
    phoneAdditional?: string;
    whatsappNumber?: string;
    /**
     * Id города в программе лояльности
     */
    cityId?: number;
    /**
     * Список Id категорий в программе лояльности
     */
    favoriteCategories?: Array<string>;
}

